module.exports = __webpack_public_path__ + "media/img/pages/companies/groupe-mutuel-3e0dcbcc5bd6d578287569a6bab9cd85.jpg";